// import React, { useState, useEffect, useRef } from "react";
// import "./testscheduling.css";
// import DropDown from "./Dropwon-testscheduling";
// import DropDown3 from "./Drodpwon-Catch";
// import InputComponent from "./Input-testscheduling";
// import introgativeImgBlue from "../../../Assets/Images/CommanImages/IntrogativeBlue.png";
// import TextEditor from "../../Landing/components/TextEditor";
// import MinusImg from "../../../Assets/Images/CommanImages/MinusGrey.png";
// import SuccessImg from "../../../Assets/Images/CommanImages/success.png";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
// import Colors from "../../../Constants/Colors";
// import ReflectDropdown from "../../../Components/ReflectDropdown/ReflectDropdwon";
// import { useNavigate } from "react-router-dom";
// import EndPoints from "../../../Api/Endpoints";
// import { GET, POST } from "../../../Api/HttpsMethods";
// import CoursePlanTable from "./CoursePlanTable";

// const getCurrentDateTime = () => {
//   const n = new Date();
//   return (
//     [n.getFullYear(), String(n.getMonth() + 1).padStart(2, "0"), String(n.getDate()).padStart(2, "0")].join("-") +
//     "T" +
//     [String(n.getHours()).padStart(2, "0"), String(n.getMinutes()).padStart(2, "0")].join(":")
//   );
// };

// const TestScheduling = ({ dataClient, setMessageBox, setIsMessageBoxVisible, setActiveImg }) => {
//   const navigate = useNavigate();

//   // ── auth ─────────────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (dataClient) {
//       const u = dataClient?.client_schema_name?.[6]?.[0];
//       if (u?.user_name)        sessionStorage.setItem("user_name",      u.user_name);
//       if (u?.client_branch_id) sessionStorage.setItem("clientBranchId", u.client_branch_id);
//       if (u?.client_id)        sessionStorage.setItem("clientId",        u.client_id);
//     }
//   }, [dataClient]);

//   const userName       = dataClient?.client_schema_name?.[6]?.[0]?.user_name       || sessionStorage.getItem("user_name")      || "";
//   const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || sessionStorage.getItem("clientBranchId") || null;
//   const clientId       = dataClient?.client_schema_name?.[6]?.[0]?.client_id        || sessionStorage.getItem("clientId")        || null;

//   // ── lookup data ───────────────────────────────────────────────────────────
//   const [allTestSeries,         setAllTestSeries]         = useState([]);
//   const [courses,               setCourses]               = useState([]);
//   const [markingSchemeList,     setMarkingSchemeList]     = useState([]);
//   const [testTemplates,         setTestTemplates]         = useState([]);
//   const [coursePlans,           setCoursePlans]           = useState([]);
//   const [quesPaperList,         setQuesPaperList]         = useState([]);

//   // ── selected / derived ───────────────────────────────────────────────────
//   const [selectedTestSeriesId,  setSelectedTestSeriesId]  = useState(null);
//   const [selectedTestSeriesObj, setSelectedTestSeriesObj] = useState(null);
//   const [testSeriesDescription, setTestSeriesDescription] = useState("");
//   const [courseOpted,           setCourseOpted]           = useState("");
//   const [selectedQuesPaperId,   setSelectedQuesPaperId]   = useState(null);
//   const [quesPaperDescription,  setQuesPaperDescription]  = useState("");
//   const [quesPaperCreatedBy,    setQuesPaperCreatedBy]    = useState("");
//   const [testSeriesSubjects,    setTestSeriesSubjects]    = useState("");
//   const [paperSubjects,         setPaperSubjects]         = useState([]);

//   const isAITS        = !!selectedTestSeriesObj?.ts_name?.toUpperCase().includes("AITS");
//   const seriesSelected = !!selectedTestSeriesId;

//   // ── schedule fields ───────────────────────────────────────────────────────
//   const [testName,          setTestName]          = useState("");
//   const [testDescription,   setTestDescription]   = useState("");
//   const [testWindowStart,   setTestWindowStart]   = useState("");
//   const [testWindowEnd,     setTestWindowEnd]     = useState("");
//   const [duration,          setDuration]          = useState("");
//   const [folderName,        setFolderName]        = useState("");
//   const [folderLevelData,   setFolderLevelData]   = useState([]);
//   const [folderPickerOpen,  setFolderPickerOpen]  = useState(false);
//   const [expandedLevel1,    setExpandedLevel1]    = useState(null);
//   const [expandedLevel2,    setExpandedLevel2]    = useState(null);
//   const [folderSearchText,  setFolderSearchText]  = useState("");
//   const [selectedLevel1Id,  setSelectedLevel1Id]  = useState(null);
//   const [selectedLevel2Id,  setSelectedLevel2Id]  = useState(null);
//   const [selectedLevel3Id,  setSelectedLevel3Id]  = useState(null);
//   const folderPickerRef = useRef(null);
//   const folderDropdownRef = useRef(null);
//   const [numberOfSets,      setNumberOfSets]      = useState(1);
//   const [shuffleSubjects,   setShuffleSubjects]   = useState(false);
//   const [shuffleQuestions,  setShuffleQuestions]  = useState(true);
//   const [shuffleOptions,    setShuffleOptions]    = useState(false);
//   const [instructionsHtml,  setInstructionsHtml]  = useState("");

//   // ── marking scheme state ─────────────────────────────────────────────────
//   const [selectedMarkingSchemes, setSelectedMarkingSchemes] = useState({});

//   // ── course plan selection ─────────────────────────────────────────────────
//   const [selectedPlanIds,  setSelectedPlanIds]  = useState([]);

//   // ── collapse state ────────────────────────────────────────────────────────
//   const [detailsVisible,       setDetailsVisible]       = useState(true);
//   const [coursePlansVisible,   setCoursePlansVisible]   = useState(true);
//   const [markingSchemeVisible, setMarkingSchemeVisible] = useState(true);

//   // ═══════════════════════════════════════════════════════════════════════════
//   //  FETCHES
//   // ═══════════════════════════════════════════════════════════════════════════

//   useEffect(() => {
//     GET.withToken(EndPoints.PRISM_GET_COURSES)
//       .then((d) => { if (Array.isArray(d)) setCourses(d); })
//       .catch((e) => console.error("courses:", e));
//   }, []);

//   useEffect(() => {
//     if (!clientBranchId) return;
//     GET.withToken(`${EndPoints.PRISM_GET_TEST_SERIES_LIST_BY_BRANCH}?client_branch_id=${clientBranchId}`)
//       .then((r) => { if (r?.status === 200 && Array.isArray(r.data)) setAllTestSeries(r.data); })
//       .catch((e) => console.error("test series:", e));
//   }, [clientBranchId]);

//   useEffect(() => {
//     GET.withToken(EndPoints.PRISM_GET_MARKING_SCHEME_LIST)
//       .then((r) => { if (r?.status_code === 200 || r?.status === "success") setMarkingSchemeList(r.data); })
//       .catch((e) => console.error("marking schemes:", e));
//   }, []);

//   useEffect(() => {
//     if (!clientBranchId || !courseOpted) { setQuesPaperList([]); return; }
//     const courseId = typeof courseOpted === "object" ? courseOpted.id : courseOpted;
//     const tsId     = selectedTestSeriesId ? `&test_series_id=${selectedTestSeriesId}` : "";
//     GET.withToken(`${EndPoints.PRISM_GET_QUES_PAPER_LIST_V1}?branch_id=${clientBranchId}&course_id=${courseId}${tsId}`)
//       .then((r) => { if (r?.status === 200) setQuesPaperList(Array.isArray(r.data) ? r.data : []); })
//       .catch((e) => console.error("ques papers:", e));
//   }, [clientBranchId, courseOpted, selectedTestSeriesId]);

//   useEffect(() => {
//     if (!userName || !clientBranchId) return;
//     GET.withToken(`${EndPoints.PRISM_GET_TEST_INSTRUCTIONS_TEMPLATE_LIST_V1}?username=${userName}&branch_id=${clientBranchId}`)
//       .then((d) => { if (Array.isArray(d)) setTestTemplates(d); })
//       .catch((e) => console.error("templates:", e));
//   }, [userName, clientBranchId]);

//   useEffect(() => {
//     if (!courseOpted) { setCoursePlans([]); setSelectedPlanIds([]); return; }
//     const courseId = typeof courseOpted === "object" ? courseOpted.id : courseOpted;
//     GET.withToken(`${EndPoints.PRISM_GET_COURSE_PLAN}?course_id=${courseId}`)
//       .then((r) => {
//         if (r?.status === 200 && Array.isArray(r.data)) setCoursePlans(r.data);
//         else setCoursePlans([]);
//         setSelectedPlanIds([]);
//       })
//       .catch((e) => { console.error("course plans:", e); setCoursePlans([]); });
//   }, [courseOpted]);

//   useEffect(() => {
//     if (!coursePlans.length) { setFolderLevelData([]); return; }
//     const planId = coursePlans[0].course_plan_id;
//     const url = `${EndPoints.PRISM_GET_TEST_FOLDER_STRUCTURE}?course_plan_id=${planId}`;
//     GET.withToken(url)
//       .then((r) => { if (r?.status === 200 && Array.isArray(r.data)) setFolderLevelData(r.data); })
//       .catch((e) => console.error("folder levels:", e));
//   }, [coursePlans]);

//   useEffect(() => {
//     const handler = (e) => {
//       if (
//         folderPickerOpen &&
//         folderPickerRef.current && !folderPickerRef.current.contains(e.target) &&
//         (!folderDropdownRef.current || !folderDropdownRef.current.contains(e.target))
//       ) {
//         setFolderPickerOpen(false);
//         setExpandedLevel1(null); setExpandedLevel2(null);
//         setFolderSearchText("");
//       }
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, [folderPickerOpen]);

//   useEffect(() => {
//     if (!selectedQuesPaperId) {
//       setQuesPaperDescription(""); setQuesPaperCreatedBy("");
//       setTestSeriesSubjects(""); setPaperSubjects([]); setSelectedMarkingSchemes({});
//       return;
//     }
//     const paper = quesPaperList.find((qp) => Number(qp.ques_paper_id) === parseInt(selectedQuesPaperId, 10));
//     if (paper) {
//       setQuesPaperDescription(paper.description || "");
//       setQuesPaperCreatedBy(paper.created_by || "");
//       const subjects = Array.isArray(paper.subjects) ? paper.subjects : [];
//       const sorted = [...subjects].sort((a, b) =>
//         (a.subject_superset_name || "").localeCompare(b.subject_superset_name || "")
//       );
//       setTestSeriesSubjects(sorted.map((s) => s.subject_superset_name || s.subject_name || "").filter(Boolean).join(", "));
//       setPaperSubjects(sorted);
//       setSelectedMarkingSchemes({});
//     } else {
//       setQuesPaperDescription(""); setQuesPaperCreatedBy("");
//       setTestSeriesSubjects(""); setPaperSubjects([]); setSelectedMarkingSchemes({});
//     }
//   }, [selectedQuesPaperId, quesPaperList]);

//   // ═══════════════════════════════════════════════════════════════════════════
//   //  HANDLERS
//   // ═══════════════════════════════════════════════════════════════════════════

//   const handleTestSeriesSelect = (id) => {
//     setSelectedTestSeriesId(id);
//     if (!id || id === 0) {
//       setSelectedTestSeriesObj(null); setTestSeriesDescription(""); setCourseOpted("");
//       setSelectedQuesPaperId(null); setDuration(""); setSelectedMarkingSchemes({});
//       setFolderName(""); setSelectedLevel1Id(null); setSelectedLevel2Id(null); setSelectedLevel3Id(null); setFolderLevelData([]);
//       return;
//     }
//     const series = allTestSeries.find((ts) => ts.ts_id === id);
//     if (series) {
//       setSelectedTestSeriesObj(series);
//       setTestSeriesDescription(series.ts_desc || "");
//       setCourseOpted({ id: series.course_id, label: series.course_name });
//       if (series.duration_mins) setDuration(String(series.duration_mins));
//     }
//     setSelectedQuesPaperId(null);
//     setSelectedMarkingSchemes({});
//   };

//   const getDisplaySubjects = () =>
//     paperSubjects
//       .filter((s, i, arr) => arr.findIndex((x) => x.subject_superset_id === s.subject_superset_id) === i)
//       .sort((a, b) => (a.subject_superset_name || "").localeCompare(b.subject_superset_name || ""));

//   const getDeduplicatedSections = (subject) => {
//     const raw = Array.isArray(subject.sections) && subject.sections.length > 0
//       ? subject.sections : [{ section_no: 1, section_name: "Section 1" }];
//     return raw
//       .filter((sec, i, arr) => arr.findIndex((s) => s.section_name === sec.section_name) === i)
//       .sort((a, b) => (a.section_name || "").localeCompare(b.section_name || ""));
//   };

//   const handleMarkingSchemeChange = (ssId, sectionIdx, value) => {
//     const changedKey = `${ssId}-${sectionIdx + 1}`;
//     setSelectedMarkingSchemes((prev) => {
//       const updated = { ...prev, [changedKey]: value };
//       getDisplaySubjects().forEach((subject) => {
//         getDeduplicatedSections(subject).forEach((_, idx) => {
//           const k = `${subject.subject_superset_id}-${idx + 1}`;
//           if (k !== changedKey && updated[k] == null) updated[k] = value;
//         });
//       });
//       return updated;
//     });
//   };

//   // ═══════════════════════════════════════════════════════════════════════════
//   //  SAVE
//   // ═══════════════════════════════════════════════════════════════════════════

//   const handleSave = async () => {
//     if (!selectedQuesPaperId) {
//       setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>Please select a Question Paper.</span></div></div>);
//       setIsMessageBoxVisible(true); setActiveImg(ErrorImg); return;
//     }
//     if (!testName.trim()) {
//       setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>Test Name is required.</span></div></div>);
//       setIsMessageBoxVisible(true); setActiveImg(ErrorImg); return;
//     }
//     if (!testWindowStart || !testWindowEnd) {
//       setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>Test Window Start and End are required.</span></div></div>);
//       setIsMessageBoxVisible(true); setActiveImg(ErrorImg); return;
//     }
//     if (!duration) {
//       setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>Duration is required.</span></div></div>);
//       setIsMessageBoxVisible(true); setActiveImg(ErrorImg); return;
//     }
//     if (!isAITS && !folderName.trim()) {
//       setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>Folder Name is required.</span></div></div>);
//       setIsMessageBoxVisible(true); setActiveImg(ErrorImg); return;
//     }
//     if (selectedPlanIds.length === 0) {
//       setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>Please select at least one Course Plan.</span></div></div>);
//       setIsMessageBoxVisible(true); setActiveImg(ErrorImg); return;
//     }

//     const sectionChars = ["a", "b", "c", "d"];
//     const subjectsPayload = getDisplaySubjects().map((subject) => {
//       const ssId     = subject.subject_superset_id;
//       const sections = getDeduplicatedSections(subject);
//       const msObj    = { ms_id_sec_a: null, ms_id_sec_b: null, ms_id_sec_c: null, ms_id_sec_d: null };
//       sections.forEach((_, idx) => {
//         const char = sectionChars[idx];
//         if (char) msObj[`ms_id_sec_${char}`] = selectedMarkingSchemes?.[`${ssId}-${idx + 1}`] ?? null;
//       });
//       return { subject_superset_id: ssId, marking_scheme: [msObj] };
//     });

//     const payload = {
//       ts_id:               selectedTestSeriesId || null,
//       ques_paper_id:       parseInt(selectedQuesPaperId),
//       test_name:           testName.trim(),
//       test_desc:           testDescription.trim() || testName.trim(),
//       test_abb:            null,
//       test_window_start:   testWindowStart,
//       test_window_end:     testWindowEnd,
//       duration_mins:       parseInt(duration) || 0,
//       no_of_sets:          isAITS ? (numberOfSets || 1) : 1,
//       test_level1_id:      selectedLevel1Id,
//       test_level2_id:      selectedLevel2Id,
//       test_level3_id:      selectedLevel3Id,
//       instructions_html:   instructionsHtml || null,
//       dedicated_client_id: clientId ? parseInt(clientId) : null,
//       test_term_date:      null,
//       shuffle_subjects:    isAITS ? shuffleSubjects  : false,
//       shuffle_questions:   isAITS ? shuffleQuestions : false,
//       shuffle_options:     isAITS ? shuffleOptions   : false,
//       created_by:          userName || "",
//       last_updated_by:     userName || "",
//       subjects:            subjectsPayload,
//       set_assignments:     selectedPlanIds.map((id) => ({ subscriber_id: id })),
//       course_plan_id_list: selectedPlanIds,
//     };

//     const url = `${EndPoints.PRISM_CREATE_TEST_SCHEDULE_V1}?shuffle_ques=${isAITS ? shuffleQuestions : true}&shuffle_subject=${isAITS ? shuffleSubjects : false}&shuffle_option=${isAITS ? shuffleOptions : false}`;

//     try {
//       const result = await POST.withToken(url, payload, { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg });
//       if (result?.status === 201 || result?.status === 200) {
//         setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>{result.message || "Test schedule created successfully!"}</span></div></div>);
//         setIsMessageBoxVisible(true); setActiveImg(SuccessImg);
//         setTimeout(() => navigate(-1), 1000);
//       }
//     } catch (e) { console.error("Error saving:", e); }
//   };

//   // ═══════════════════════════════════════════════════════════════════════════
//   //  RENDER
//   // ═══════════════════════════════════════════════════════════════════════════

//   // ── Shared styles — sourced from SemanticColors CSS variables ────────────
//   // DppInputBorder, DppInputBackground from SemanticColors TealWhiteGrey theme
//   // Gray-2 (#6A6A6A) is the canonical text color for all input fields and labels
//   const inputStyle = {
//     width: "100%",
//     padding: "8px 10px",
//     border: "1px solid var(--DppInputBorder, #d0d0d0)",
//     borderRadius: "0px",                                   // ← removed border-radius
//     fontSize: "14px",
//     boxSizing: "border-box",
//     backgroundColor: "var(--DppInputBackground, #ffffff)",
//     color: "var(--Gray-2, #6A6A6A)",                       // ← unified text color
//   };

//   const disabledStyle = {
//     ...inputStyle,
//     opacity: 0.55,
//     cursor: "not-allowed",
//     backgroundColor: "var(--DppDropdownBackground, #f5f5f5)",
//   };

//   const labelStyle = {
//     fontSize: "14px",
//     color: "var(--DppLabelText, #6A6A6A)",                 // ← unified label color
//     display: "block",
//     marginBottom: "5px",
//   };

//   const SectionHeader = ({ title, visible, onToggle }) => (
//     <div className="Header-1-C424342" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "5px" }}>
//       <span>{title}</span>
//       {visible
//         ? <img src={MinusImg} alt="collapse" style={{ cursor: "pointer", width: "24px", height: "10px" }} onClick={onToggle} />
//         : <div className="plus" style={{ cursor: "pointer", fontSize: "28px", width: "24px", height: "24px", display: "flex", alignItems: "center", justifyContent: "center", color: "#888", fontWeight: "bold" }} onClick={onToggle}>+</div>
//       }
//     </div>
//   );

//   const displaySubjects = getDisplaySubjects();

//   return (
//     <div className="Leftmargin-Main-DIV">

//       {/* ── top bar ── */}
//       <div style={{ position: "sticky", top: 0, backgroundColor: "white", zIndex: 100 }}>
//         <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "20px", width: "98%" }}>
//           <div style={{ fontSize: "30px", color: `${Colors.color1}`, fontWeight: "400", whiteSpace: "nowrap" }}>Test Scheduling</div>
//           <div>
//             <div className="row-cs-uni">
//               <button className="create-test-section-btn" style={{ marginRight: "18px", boxShadow: "0px 4px 4px 0px #00000040" }} onClick={() => navigate(-1)}>CANCEL</button>
//               <button className="create-test-section-btn" style={{ marginRight: "0px",  boxShadow: "0px 4px 4px 0px #00000040" }} onClick={handleSave}>SAVE</button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ════════════════════════════════════════════════════════
//           SECTION 1 — TEST DETAILS
//       ════════════════════════════════════════════════════════ */}
//       <SectionHeader title="TEST DETAILS" visible={detailsVisible} onToggle={() => setDetailsVisible((v) => !v)} />

//       {detailsVisible && (
//         <div className="Body-1-C424342" style={{ paddingBottom: 16 }}>

//           {/* gap: rowGap 8px, columnGap 24px — per design spec */}
//           <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", columnGap: "24px", rowGap: "8px", paddingRight: "5.5px" }}>

//             {/* Row 1: Test Series | Description | Course */}
//             <div>
//               <ReflectDropdown label="Test Series" style={{ width: "100%" }}
//                 setSelected={handleTestSeriesSelect} selected={selectedTestSeriesId}
//                 options={[{ label: "-None-", id: 0 }, ...allTestSeries.map((ts) => ({ label: `${ts.ts_name} - ${ts.course_name || ""}`, id: ts.ts_id }))]}
//                 isRequired={true}
//               />
//             </div>
//             <div>
//               <InputComponent label="Description" style={{ width: "100%" }} value={testSeriesDescription} isRequired={false} disable={true} />
//             </div>
//             <div>
//               <DropDown3 label="Course" style={{ width: "100%" }} setSelected={setCourseOpted} selected={courseOpted}
//                 options={courses.map((c) => ({ label: c.course_name, id: c.course_id }))} isRequired={false} disabled={true} />
//             </div>

//             {/* Row 2: Question Paper Name | QP Description | Subjects */}
//             <div>
//               <DropDown label="Question Paper Name" style={{ width: "100%" }}
//                 selected={selectedQuesPaperId} setSelected={setSelectedQuesPaperId}
//                 options={quesPaperList.map((qp) => ({ label: qp.ques_paper_name, id: qp.ques_paper_id }))} isRequired={true} />
//             </div>
//             <div>
//               <InputComponent label="Question Paper Description" style={{ width: "100%" }} value={quesPaperDescription} isRequired={false} disable={true} />
//             </div>
//             <div>
//               <InputComponent label="Subjects" style={{ width: "100%" }} value={testSeriesSubjects} isRequired={false} disable={true} icon={introgativeImgBlue} />
//             </div>

//             {/* Row 3: QP Created By | Test Name | Description */}
//             <div>
//               <InputComponent label="Question Paper Created By" style={{ width: "100%" }} value={quesPaperCreatedBy} isRequired={false} disable={true} />
//             </div>
//             <div>
//               <label style={labelStyle}>Test Name <span style={{ color: "red" }}>*</span></label>
//               <input type="text" style={seriesSelected ? inputStyle : disabledStyle} value={testName}
//                 placeholder="Enter test name" disabled={!seriesSelected} onChange={(e) => setTestName(e.target.value)} />
//             </div>
//             <div>
//               <label style={labelStyle}>Description</label>
//               <input type="text" style={seriesSelected ? inputStyle : disabledStyle} value={testDescription}
//                 placeholder="Enter description" disabled={!seriesSelected} onChange={(e) => setTestDescription(e.target.value)} />
//             </div>

//             {/* Row 4: Test Window Start | Test Window End | Folder Name */}
//             <div>
//               <label style={labelStyle}>Test Window Start <span style={{ color: "red" }}>*</span></label>
//               <input type="datetime-local" style={seriesSelected ? inputStyle : disabledStyle}
//                 min={getCurrentDateTime()} value={testWindowStart} disabled={!seriesSelected}
//                 onChange={(e) => setTestWindowStart(e.target.value)} />
//             </div>
//             <div>
//               <label style={labelStyle}>Test Window End <span style={{ color: "red" }}>*</span></label>
//               <input type="datetime-local" style={seriesSelected ? inputStyle : disabledStyle}
//                 min={testWindowStart || getCurrentDateTime()} value={testWindowEnd} disabled={!seriesSelected}
//                 onChange={(e) => setTestWindowEnd(e.target.value)} />
//             </div>
//             <div style={{ position: "relative" }}>
//               <label style={labelStyle}>
//                 Folder Name {!isAITS && seriesSelected && <span style={{ color: "red" }}>*</span>}
//               </label>
//               {/* Folder picker input */}
//               <div ref={folderPickerRef} style={{ position: "relative" }}>
//                 <input
//                   type="text"
//                   style={
//                     seriesSelected && !isAITS
//                       ? { ...inputStyle, paddingRight: "30px" }
//                       : { ...disabledStyle, paddingRight: "30px" }
//                   }
//                   value={folderPickerOpen ? folderSearchText : folderName}
//                   placeholder="Select or search folder..."
//                   disabled={!seriesSelected || isAITS}
//                   onChange={(e) => {
//                     setFolderSearchText(e.target.value);
//                     setExpandedLevel1(null); setExpandedLevel2(null);
//                     if (!folderPickerOpen) setFolderPickerOpen(true);
//                   }}
//                   onFocus={() => { if (!isAITS && seriesSelected) { setFolderPickerOpen(true); setFolderSearchText(""); } }}
//                 />
//                 <span
//                   onClick={() => { if (!isAITS && seriesSelected) { setFolderPickerOpen((v) => !v); setFolderSearchText(""); setExpandedLevel1(null); setExpandedLevel2(null); } }}
//                   style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", color: "var(--Gray-2, #6A6A6A)", cursor: "pointer", fontSize: "11px" }}
//                 >▼</span>
//               </div>

//               {/* Folder dropdown */}
//               {folderPickerOpen && !isAITS && (
//                 <div ref={folderDropdownRef} style={{ position: "absolute", top: "100%", left: 0, zIndex: 9999, marginTop: "2px", minWidth: "220px" }}>

//                   {folderSearchText.trim() ? (
//                     <div style={{ backgroundColor: "var(--DppInputBackground, #fff)", border: "1px solid var(--DppInputBorder, #ddd)", borderRadius: "0px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", maxHeight: "220px", overflowY: "auto", width: "360px" }}>
//                       {(() => {
//                         const term = folderSearchText.toLowerCase();
//                         const results = [];
//                         folderLevelData.forEach((l1) => {
//                           (l1.level2 || []).forEach((l2) => {
//                             const path2 = `${l1.name || "Level 1"} > ${l2.name || "Level 2"}`;
//                             if ((l2.name || "").toLowerCase().includes(term)) results.push({ path: path2, l1Id: l1.test_level1_id, l2Id: l2.test_level2_id, l3Id: null });
//                             (l2.level3 || []).forEach((l3) => {
//                               const path3 = `${path2} > ${l3.name || "Level 3"}`;
//                               if ((l3.name || "").toLowerCase().includes(term)) results.push({ path: path3, l1Id: l1.test_level1_id, l2Id: l2.test_level2_id, l3Id: l3.test_level3_id });
//                             });
//                           });
//                         });
//                         if (!results.length) return <div style={{ padding: "12px", color: "var(--Gray-2, #6A6A6A)", fontSize: "14px", textAlign: "center" }}>No results found</div>;
//                         return results.map((r, i) => (
//                           <div key={i} onClick={() => { setFolderName(r.path); setSelectedLevel1Id(r.l1Id); setSelectedLevel2Id(r.l2Id); setSelectedLevel3Id(r.l3Id); setFolderPickerOpen(false); setFolderSearchText(""); }}
//                             style={{ padding: "8px 12px", cursor: "pointer", borderBottom: "1px solid var(--DppDropdownItemBorder, #f0f0f0)", fontSize: "14px", color: "var(--Gray-2, #6A6A6A)" }}
//                             onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "var(--DppDropdownHoverBackground, #f0f7ff)"}
//                             onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "var(--DppInputBackground, #fff)"}>
//                             {r.path}
//                           </div>
//                         ));
//                       })()}
//                     </div>
//                   ) : (
//                     <div style={{ display: "flex", alignItems: "flex-start" }}>

//                       {/* Level 1 */}
//                       <div style={{ backgroundColor: "var(--DppInputBackground, #fff)", border: "1px solid var(--DppInputBorder, #ddd)", borderRadius: "0px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", width: "170px", maxHeight: "220px", overflowY: "auto" }}>
//                         {folderLevelData.length === 0
//                           ? <div style={{ padding: "12px", color: "var(--Gray-2, #6A6A6A)", fontSize: "14px" }}>No folders available</div>
//                           : folderLevelData.map((l1) => (
//                             <div key={l1.test_level1_id}
//                               onMouseEnter={() => { setExpandedLevel1(l1.test_level1_id); setExpandedLevel2(null); }}
//                               style={{ padding: "8px 10px", backgroundColor: expandedLevel1 === l1.test_level1_id ? "var(--DppDropdownHoverBackground, #f0f7ff)" : "var(--DppInputBackground, #fff)", cursor: "default", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid var(--DppDropdownItemBorder, #f0f0f0)", fontSize: "14px", color: "var(--Gray-2, #6A6A6A)", fontWeight: "500" }}>
//                               <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{l1.name || "(No name)"}</span>
//                               {(l1.level2 || []).length > 0 && <span style={{ fontSize: "9px", color: "var(--Gray-2, #6A6A6A)", flexShrink: 0, marginLeft: "4px" }}>▶</span>}
//                             </div>
//                           ))
//                         }
//                       </div>

//                       {/* Level 2 */}
//                       {expandedLevel1 && (() => {
//                         const l1 = folderLevelData.find((x) => x.test_level1_id === expandedLevel1);
//                         if (!l1?.level2?.length) return null;
//                         return (
//                           <div style={{ backgroundColor: "var(--DppInputBackground, #fff)", border: "1px solid var(--DppInputBorder, #ddd)", borderRadius: "0px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", width: "170px", maxHeight: "220px", overflowY: "auto", marginLeft: "3px" }}>
//                             {l1.level2.map((l2) => (
//                               <div key={l2.test_level2_id}
//                                 onMouseEnter={() => setExpandedLevel2(l2.test_level2_id)}
//                                 onClick={() => { const path = `${l1.name || "L1"} > ${l2.name || "L2"}`; setFolderName(path); setSelectedLevel1Id(l1.test_level1_id); setSelectedLevel2Id(l2.test_level2_id); setSelectedLevel3Id(null); setFolderPickerOpen(false); setExpandedLevel1(null); setExpandedLevel2(null); }}
//                                 style={{ padding: "8px 10px", backgroundColor: expandedLevel2 === l2.test_level2_id ? "var(--DppDropdownHoverBackground, #f0f7ff)" : "var(--DppInputBackground, #fff)", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid var(--DppDropdownItemBorder, #f0f0f0)", fontSize: "14px", color: "var(--Gray-2, #6A6A6A)" }}>
//                                 <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{l2.name || "(No name)"}</span>
//                                 {(l2.level3 || []).length > 0 && <span style={{ fontSize: "9px", color: "var(--Gray-2, #6A6A6A)", flexShrink: 0, marginLeft: "4px" }}>▶</span>}
//                               </div>
//                             ))}
//                           </div>
//                         );
//                       })()}

//                       {/* Level 3 */}
//                       {expandedLevel2 && (() => {
//                         const l1 = folderLevelData.find((x) => x.test_level1_id === expandedLevel1);
//                         const l2 = l1?.level2?.find((x) => x.test_level2_id === expandedLevel2);
//                         if (!l2?.level3?.length) return null;
//                         return (
//                           <div style={{ backgroundColor: "var(--DppInputBackground, #fff)", border: "1px solid var(--DppInputBorder, #ddd)", borderRadius: "0px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", width: "170px", maxHeight: "220px", overflowY: "auto", marginLeft: "3px" }}>
//                             {l2.level3.map((l3) => (
//                               <div key={l3.test_level3_id}
//                                 onClick={() => { const path = `${l1.name || "L1"} > ${l2.name || "L2"} > ${l3.name || "L3"}`; setFolderName(path); setSelectedLevel1Id(l1.test_level1_id); setSelectedLevel2Id(l2.test_level2_id); setSelectedLevel3Id(l3.test_level3_id); setFolderPickerOpen(false); setExpandedLevel1(null); setExpandedLevel2(null); }}
//                                 style={{ padding: "8px 10px", cursor: "pointer", borderBottom: "1px solid var(--DppDropdownItemBorder, #f0f0f0)", fontSize: "14px", color: "var(--Gray-2, #6A6A6A)" }}
//                                 onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "var(--DppDropdownHoverBackground, #f0f7ff)"}
//                                 onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "var(--DppInputBackground, #fff)"}>
//                                 <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "block" }}>{l3.name || "(No name)"}</span>
//                               </div>
//                             ))}
//                           </div>
//                         );
//                       })()}
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>

//             {/* Row 5: Duration | No. of Sets | Shuffle Subject */}
//             <div>
//               <label style={labelStyle}>Duration (mins) <span style={{ color: "red" }}>*</span></label>
//               <input type="number" style={seriesSelected ? inputStyle : disabledStyle}
//                 value={duration} placeholder="In minutes" disabled={!seriesSelected}
//                 onChange={(e) => setDuration(e.target.value)} />
//             </div>
//             <div>
//               <ReflectDropdown
//                 label="No. of Sets"
//                 style={{ width: "100%" }}
//                 options={[1,2,3,4,5,6].map((n) => ({ label: String(n), id: n }))}
//                 selected={numberOfSets}
//                 setSelected={(val) => setNumberOfSets(val)}
//                 isDisabled={!seriesSelected || !isAITS}
//               />
//             </div>
//             <div>
//               <ReflectDropdown
//                 label="Shuffle Subject"
//                 style={{ width: "100%" }}
//                 options={[{ label: "No", id: 0 }, { label: "Yes", id: 1 }]}
//                 selected={shuffleSubjects ? 1 : 0}
//                 setSelected={(val) => setShuffleSubjects(Boolean(val))}
//                 isDisabled={!seriesSelected || !isAITS}
//               />
//             </div>

//             {/* Row 6: Shuffle Question | Shuffle Option | empty */}
//             <div>
//               <ReflectDropdown
//                 label="Shuffle Question"
//                 style={{ width: "100%" }}
//                 options={[{ label: "Yes", id: 1 }, { label: "No", id: 0 }]}
//                 selected={shuffleQuestions ? 1 : 0}
//                 setSelected={(val) => setShuffleQuestions(Boolean(val))}
//                 isDisabled={!seriesSelected || !isAITS}
//               />
//             </div>
//             <div>
//               <ReflectDropdown
//                 label="Shuffle Option"
//                 style={{ width: "100%" }}
//                 options={[{ label: "No", id: 0 }, { label: "Yes", id: 1 }]}
//                 selected={shuffleOptions ? 1 : 0}
//                 setSelected={(val) => setShuffleOptions(Boolean(val))}
//                 isDisabled={!seriesSelected || !isAITS}
//               />
//             </div>
//             <div />

//             {/* Instructions — spans all 3 columns */}
//             <div style={{ gridColumn: "1 / -1" }}>
//               <TextEditor templates={testTemplates} value={instructionsHtml}
//                 setValue={seriesSelected ? setInstructionsHtml : () => {}} />
//             </div>

//           </div>
//         </div>
//       )}

//       {/* ════════════════════════════════════════════════════════
//           SECTION 2 — COURSE PLANS
//       ════════════════════════════════════════════════════════ */}
//       <div style={{ marginTop: "20px" }}>
//         <SectionHeader title="COURSE PLANS" visible={coursePlansVisible} onToggle={() => setCoursePlansVisible((v) => !v)} />

//         {coursePlansVisible && (
//           <div className="Body-1-C424342" style={{ paddingBottom: 16 }}>
//             {!seriesSelected ? (
//               <div style={{ color: "var(--Gray-2, #6A6A6A)", fontSize: "14px", padding: "8px 15px" }}>Select a Test Series to view course plans.</div>
//             ) : (
//               <div style={{ paddingRight: "5.5px" }}>
//                 <CoursePlanTable coursePlans={coursePlans} selectedPlanIds={selectedPlanIds} setSelectedPlanIds={setSelectedPlanIds} />
//               </div>
//             )}
//           </div>
//         )}
//       </div>

//       {/* ════════════════════════════════════════════════════════
//           SECTION 3 — MARKING SCHEME
//       ════════════════════════════════════════════════════════ */}
//       <div style={{ marginTop: "20px" }}>
//         <SectionHeader title="MARKING SCHEME" visible={markingSchemeVisible} onToggle={() => setMarkingSchemeVisible((v) => !v)} />

//         {markingSchemeVisible && (
//           <div className="Body-1-C424342" style={{ padding: "15px", color: `${Colors.color1}`, marginBottom: "10px" }}>
//             {!seriesSelected ? (
//               <div style={{ color: "var(--Gray-2, #6A6A6A)", fontSize: "14px", padding: "8px 0" }}>Select a Test Series to configure marking scheme.</div>
//             ) : displaySubjects.length === 0 ? (
//               <div style={{ color: "var(--Gray-2, #6A6A6A)", fontSize: "14px", padding: "8px 0" }}>Select a question paper to configure marking scheme.</div>
//             ) : (
//               <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", columnGap: "24px", rowGap: "8px", paddingRight: "5.5px" }}>
//                 {displaySubjects.map((subject) => {
//                   const ssId     = subject.subject_superset_id;
//                   const ssName   = subject.subject_superset_name || subject.subject_name || "";
//                   const sections = getDeduplicatedSections(subject);
//                   return sections.map((section, sectionIdx) => {
//                     const key        = `${ssId}-${sectionIdx + 1}`;
//                     const selectedId = selectedMarkingSchemes?.[key] ?? null;
//                     const scheme     = markingSchemeList.find((ms) => ms.ms_id === selectedId);
//                     return (
//                       <React.Fragment key={`${ssId}-${section.section_no}-${sectionIdx}`}>
//                         {/* Col 1: label + dropdown */}
//                         <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", minWidth: 0 }}>
//                           <span style={{ fontSize: "14px", color: "var(--Gray-2, #6A6A6A)", whiteSpace: "nowrap", flexShrink: 0 }}>
//                             {ssName} - {section.section_name || `Section ${sectionIdx + 1}`}
//                           </span>
//                           <div style={{ width: "300px", flexShrink: 0 }}>
//                             <ReflectDropdown
//                               style={{ width: "100%" }}
//                               options={markingSchemeList.map((ms) => ({ label: ms.ms_name, id: ms.ms_id }))}
//                               selected={selectedId}
//                               setSelected={(val) => handleMarkingSchemeChange(ssId, sectionIdx, val)}
//                             />
//                           </div>
//                         </div>
//                         {/* Col 2: description */}
//                         <div style={{ display: "flex", alignItems: "center", fontSize: "14px", color: "var(--Gray-2, #6A6A6A)", minWidth: 0, overflow: "hidden" }}>
//                           <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
//                             {scheme ? `${scheme.expression} ; ${scheme.ms_desc}` : "—"}
//                           </span>
//                         </div>
//                         {/* Col 3: blank */}
//                         <div />
//                       </React.Fragment>
//                     );
//                   });
//                 })}
//               </div>
//             )}
//           </div>
//         )}
//       </div>

//       <div style={{ height: "80px" }} />
//     </div>
//   );
// };

// export default TestScheduling;











































import React, { useState, useEffect, useRef } from "react";
import "./testscheduling.css";
import DropDown from "./Dropwon-testscheduling";
import DropDown3 from "./Drodpwon-Catch";
import InputComponent from "./Input-testscheduling";
import introgativeImgBlue from "../../../Assets/Images/CommanImages/IntrogativeBlue.png";
import TextEditor from "../../Landing/components/TextEditor";
import MinusImg from "../../../Assets/Images/CommanImages/MinusGrey.png";
import SuccessImg from "../../../Assets/Images/CommanImages/success.png";
import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
import WarnningIcon from "../../../Assets/Images/CommanImages/Warning.png";
import Colors from "../../../Constants/Colors";
import ReflectDropdown from "../../../Components/ReflectDropdown/ReflectDropdwon";
import { useNavigate } from "react-router-dom";
import EndPoints from "../../../Api/Endpoints";
import { GET, POST } from "../../../Api/HttpsMethods";
import CoursePlanTable from "./CoursePlanTable";

const getCurrentDateTime = () => {
  const n = new Date();
  return (
    [n.getFullYear(), String(n.getMonth() + 1).padStart(2, "0"), String(n.getDate()).padStart(2, "0")].join("-") +
    "T" +
    [String(n.getHours()).padStart(2, "0"), String(n.getMinutes()).padStart(2, "0")].join(":")
  );
};

const TestScheduling = ({ dataClient, setMessageBox, setIsMessageBoxVisible, setActiveImg }) => {
  const navigate = useNavigate();

  // ── auth ─────────────────────────────────────────────────────────────────
  useEffect(() => {
    if (dataClient) {
      const u = dataClient?.client_schema_name?.[6]?.[0];
      if (u?.user_name)        sessionStorage.setItem("user_name",      u.user_name);
      if (u?.client_branch_id) sessionStorage.setItem("clientBranchId", u.client_branch_id);
      if (u?.client_id)        sessionStorage.setItem("clientId",        u.client_id);
    }
  }, [dataClient]);

  const userName       = dataClient?.client_schema_name?.[6]?.[0]?.user_name       || sessionStorage.getItem("user_name")      || "";
  const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || sessionStorage.getItem("clientBranchId") || null;
  const clientId       = dataClient?.client_schema_name?.[6]?.[0]?.client_id        || sessionStorage.getItem("clientId")        || null;

  // ── lookup data ───────────────────────────────────────────────────────────
  const [allTestSeries,         setAllTestSeries]         = useState([]);
  const [courses,               setCourses]               = useState([]);
  const [markingSchemeList,     setMarkingSchemeList]     = useState([]);
  const [testTemplates,         setTestTemplates]         = useState([]);
  const [coursePlans,           setCoursePlans]           = useState([]);
  const [quesPaperList,         setQuesPaperList]         = useState([]);

  // ── selected / derived ───────────────────────────────────────────────────
  const [selectedTestSeriesId,  setSelectedTestSeriesId]  = useState(null);
  const [selectedTestSeriesObj, setSelectedTestSeriesObj] = useState(null);
  const [testSeriesDescription, setTestSeriesDescription] = useState("");
  const [courseOpted,           setCourseOpted]           = useState("");
  const [selectedQuesPaperId,   setSelectedQuesPaperId]   = useState(null);
  const [quesPaperDescription,  setQuesPaperDescription]  = useState("");
  const [quesPaperCreatedBy,    setQuesPaperCreatedBy]    = useState("");
  const [testSeriesSubjects,    setTestSeriesSubjects]    = useState("");
  const [paperSubjects,         setPaperSubjects]         = useState([]);

  const isAITS        = !!selectedTestSeriesObj?.ts_name?.toUpperCase().includes("AITS");
  const seriesSelected = !!selectedTestSeriesId;

  // ── schedule fields ───────────────────────────────────────────────────────
  const [testName,          setTestName]          = useState("");
  const [testDescription,   setTestDescription]   = useState("");
  const [testWindowStart,   setTestWindowStart]   = useState("");
  const [testWindowEnd,     setTestWindowEnd]     = useState("");
  const [duration,          setDuration]          = useState("");
  const [folderName,        setFolderName]        = useState("");
  const [folderLevelData,   setFolderLevelData]   = useState([]);
  const [folderPickerOpen,  setFolderPickerOpen]  = useState(false);
  const [expandedLevel1,    setExpandedLevel1]    = useState(null);
  const [expandedLevel2,    setExpandedLevel2]    = useState(null);
  const [folderSearchText,  setFolderSearchText]  = useState("");
  const [selectedLevel1Id,  setSelectedLevel1Id]  = useState(null);
  const [selectedLevel2Id,  setSelectedLevel2Id]  = useState(null);
  const [selectedLevel3Id,  setSelectedLevel3Id]  = useState(null);
  const folderPickerRef = useRef(null);
  const folderDropdownRef = useRef(null);
  const [numberOfSets,      setNumberOfSets]      = useState(1);
  const [shuffleSubjects,   setShuffleSubjects]   = useState(false);
  const [shuffleQuestions,  setShuffleQuestions]  = useState(true);
  const [shuffleOptions,    setShuffleOptions]    = useState(false);
  const [instructionsHtml,  setInstructionsHtml]  = useState("");

  // ── marking scheme state ─────────────────────────────────────────────────
  const [selectedMarkingSchemes, setSelectedMarkingSchemes] = useState({});

  // ── course plan selection ─────────────────────────────────────────────────
  const [selectedPlanIds,  setSelectedPlanIds]  = useState([]);

  // ── collapse state ────────────────────────────────────────────────────────
  const [detailsVisible,       setDetailsVisible]       = useState(true);
  const [coursePlansVisible,   setCoursePlansVisible]   = useState(true);
  const [markingSchemeVisible, setMarkingSchemeVisible] = useState(true);

  // ═══════════════════════════════════════════════════════════════════════════
  //  FETCHES
  // ═══════════════════════════════════════════════════════════════════════════

  useEffect(() => {
    GET.withToken(EndPoints.PRISM_GET_COURSES)
      .then((d) => { if (Array.isArray(d)) setCourses(d); })
      .catch((e) => console.error("courses:", e));
  }, []);

  useEffect(() => {
    if (!clientBranchId) return;
    GET.withToken(`${EndPoints.PRISM_GET_TEST_SERIES_LIST_BY_BRANCH}?client_branch_id=${clientBranchId}`)
      .then((r) => { if (r?.status === 200 && Array.isArray(r.data)) setAllTestSeries(r.data); })
      .catch((e) => console.error("test series:", e));
  }, [clientBranchId]);

  useEffect(() => {
    GET.withToken(EndPoints.PRISM_GET_MARKING_SCHEME_LIST)
      .then((r) => { if (r?.status_code === 200 || r?.status === "success") setMarkingSchemeList(r.data); })
      .catch((e) => console.error("marking schemes:", e));
  }, []);

  useEffect(() => {
    if (!clientBranchId || !courseOpted) { setQuesPaperList([]); return; }
    const courseId = typeof courseOpted === "object" ? courseOpted.id : courseOpted;
    const tsId     = selectedTestSeriesId ? `&test_series_id=${selectedTestSeriesId}` : "";
    GET.withToken(`${EndPoints.PRISM_GET_QUES_PAPER_LIST_V1}?branch_id=${clientBranchId}&course_id=${courseId}${tsId}`)
      .then((r) => { if (r?.status === 200) setQuesPaperList(Array.isArray(r.data) ? r.data : []); })
      .catch((e) => console.error("ques papers:", e));
  }, [clientBranchId, courseOpted, selectedTestSeriesId]);

  useEffect(() => {
    if (!userName || !clientBranchId) return;
    GET.withToken(`${EndPoints.PRISM_GET_TEST_INSTRUCTIONS_TEMPLATE_LIST_V1}?username=${userName}&branch_id=${clientBranchId}`)
      .then((d) => { if (Array.isArray(d)) setTestTemplates(d); })
      .catch((e) => console.error("templates:", e));
  }, [userName, clientBranchId]);

  useEffect(() => {
    if (!courseOpted) { setCoursePlans([]); setSelectedPlanIds([]); return; }
    const courseId = typeof courseOpted === "object" ? courseOpted.id : courseOpted;
    GET.withToken(`${EndPoints.PRISM_GET_COURSE_PLAN}?course_id=${courseId}`)
      .then((r) => {
        if (r?.status === 200 && Array.isArray(r.data)) setCoursePlans(r.data);
        else setCoursePlans([]);
        setSelectedPlanIds([]);
      })
      .catch((e) => { console.error("course plans:", e); setCoursePlans([]); });
  }, [courseOpted]);

  useEffect(() => {
    if (!coursePlans.length) { setFolderLevelData([]); return; }
    const planId = coursePlans[0].course_plan_id;
    const url = `${EndPoints.PRISM_GET_TEST_FOLDER_STRUCTURE}?course_plan_id=${planId}`;
    GET.withToken(url)
      .then((r) => { if (r?.status === 200 && Array.isArray(r.data)) setFolderLevelData(r.data); })
      .catch((e) => console.error("folder levels:", e));
  }, [coursePlans]);

  useEffect(() => {
    const handler = (e) => {
      if (
        folderPickerOpen &&
        folderPickerRef.current && !folderPickerRef.current.contains(e.target) &&
        (!folderDropdownRef.current || !folderDropdownRef.current.contains(e.target))
      ) {
        setFolderPickerOpen(false);
        setExpandedLevel1(null); setExpandedLevel2(null);
        setFolderSearchText("");
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [folderPickerOpen]);

  useEffect(() => {
    if (!selectedQuesPaperId) {
      setQuesPaperDescription(""); setQuesPaperCreatedBy("");
      setTestSeriesSubjects(""); setPaperSubjects([]); setSelectedMarkingSchemes({});
      return;
    }
    const paper = quesPaperList.find((qp) => Number(qp.ques_paper_id) === parseInt(selectedQuesPaperId, 10));
    if (paper) {
      setQuesPaperDescription(paper.description || "");
      setQuesPaperCreatedBy(paper.created_by || "");
      const subjects = Array.isArray(paper.subjects) ? paper.subjects : [];
      const sorted = [...subjects].sort((a, b) =>
        (a.subject_superset_name || "").localeCompare(b.subject_superset_name || "")
      );
      setTestSeriesSubjects(sorted.map((s) => s.subject_superset_name || s.subject_name || "").filter(Boolean).join(", "));
      setPaperSubjects(sorted);
      setSelectedMarkingSchemes({});
    } else {
      setQuesPaperDescription(""); setQuesPaperCreatedBy("");
      setTestSeriesSubjects(""); setPaperSubjects([]); setSelectedMarkingSchemes({});
    }
  }, [selectedQuesPaperId, quesPaperList]);

  // ═══════════════════════════════════════════════════════════════════════════
  //  HANDLERS
  // ═══════════════════════════════════════════════════════════════════════════

  const handleTestSeriesSelect = (id) => {
    setSelectedTestSeriesId(id);
    if (!id || id === 0) {
      setSelectedTestSeriesObj(null); setTestSeriesDescription(""); setCourseOpted("");
      setSelectedQuesPaperId(null); setDuration(""); setSelectedMarkingSchemes({});
      setFolderName(""); setSelectedLevel1Id(null); setSelectedLevel2Id(null); setSelectedLevel3Id(null); setFolderLevelData([]);
      return;
    }
    const series = allTestSeries.find((ts) => ts.ts_id === id);
    if (series) {
      setSelectedTestSeriesObj(series);
      setTestSeriesDescription(series.ts_desc || "");
      setCourseOpted({ id: series.course_id, label: series.course_name });
      if (series.duration_mins) setDuration(String(series.duration_mins));
    }
    setSelectedQuesPaperId(null);
    setSelectedMarkingSchemes({});
  };

  const getDisplaySubjects = () =>
    paperSubjects
      .filter((s, i, arr) => arr.findIndex((x) => x.subject_superset_id === s.subject_superset_id) === i)
      .sort((a, b) => (a.subject_superset_name || "").localeCompare(b.subject_superset_name || ""));

  const getDeduplicatedSections = (subject) => {
    const raw = Array.isArray(subject.sections) && subject.sections.length > 0
      ? subject.sections : [{ section_no: 1, section_name: "Section 1" }];
    return raw
      .filter((sec, i, arr) => arr.findIndex((s) => s.section_name === sec.section_name) === i)
      .sort((a, b) => (a.section_name || "").localeCompare(b.section_name || ""));
  };

  const handleMarkingSchemeChange = (ssId, sectionIdx, value) => {
    const changedKey = `${ssId}-${sectionIdx + 1}`;
    setSelectedMarkingSchemes((prev) => {
      const updated = { ...prev, [changedKey]: value };
      getDisplaySubjects().forEach((subject) => {
        getDeduplicatedSections(subject).forEach((_, idx) => {
          const k = `${subject.subject_superset_id}-${idx + 1}`;
          if (k !== changedKey && updated[k] == null) updated[k] = value;
        });
      });
      return updated;
    });
  };

  // ═══════════════════════════════════════════════════════════════════════════
  //  SAVE
  // ═══════════════════════════════════════════════════════════════════════════

  const handleSave = async () => {
    if (!selectedQuesPaperId) {
      setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>Please select a Question Paper.</span></div></div>);
      setIsMessageBoxVisible(true); setActiveImg(ErrorImg); return;
    }
    if (!testName.trim()) {
      setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>Test Name is required.</span></div></div>);
      setIsMessageBoxVisible(true); setActiveImg(ErrorImg); return;
    }
    if (!testWindowStart || !testWindowEnd) {
      setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>Test Window Start and End are required.</span></div></div>);
      setIsMessageBoxVisible(true); setActiveImg(ErrorImg); return;
    }
    if (!duration) {
      setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>Duration is required.</span></div></div>);
      setIsMessageBoxVisible(true); setActiveImg(ErrorImg); return;
    }
    if (!isAITS && !folderName.trim()) {
      setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>Folder Name is required.</span></div></div>);
      setIsMessageBoxVisible(true); setActiveImg(ErrorImg); return;
    }
    if (!isAITS && folderName.trim() && selectedLevel2Id && !selectedLevel3Id) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>You have only selected till Level 2 in folder structure, do you want to continue?</span>
          </div>
          <div className="messagebox-insider2" style={{ display: "flex", gap: "10px" }}>
            <button className="messagebox-cancel-btn-ok" onClick={() => { setIsMessageBoxVisible(false); proceedSave(); }}>YES</button>
            <button className="messagebox-cancel-btn-ok" onClick={() => setIsMessageBoxVisible(false)}>NO</button>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(WarnningIcon);
      return;
    }
    if (selectedPlanIds.length === 0) {
      setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>Please select at least one Course Plan.</span></div></div>);
      setIsMessageBoxVisible(true); setActiveImg(ErrorImg); return;
    }
    proceedSave();
  };

  const proceedSave = async () => {
    const sectionChars = ["a", "b", "c", "d"];
    const subjectsPayload = getDisplaySubjects().map((subject) => {
      const ssId     = subject.subject_superset_id;
      const sections = getDeduplicatedSections(subject);
      const msObj    = { ms_id_sec_a: null, ms_id_sec_b: null, ms_id_sec_c: null, ms_id_sec_d: null };
      sections.forEach((_, idx) => {
        const char = sectionChars[idx];
        if (char) msObj[`ms_id_sec_${char}`] = selectedMarkingSchemes?.[`${ssId}-${idx + 1}`] ?? null;
      });
      return { subject_superset_id: ssId, marking_scheme: [msObj] };
    });

    const payload = {
      ts_id:               selectedTestSeriesId || null,
      ques_paper_id:       parseInt(selectedQuesPaperId),
      test_name:           testName.trim(),
      test_desc:           testDescription.trim() || testName.trim(),
      test_abb:            null,
      test_window_start:   testWindowStart,
      test_window_end:     testWindowEnd,
      duration_mins:       parseInt(duration) || 0,
      no_of_sets:          isAITS ? (numberOfSets || 1) : 1,
      test_level1_id:      selectedLevel1Id,
      test_level2_id:      selectedLevel2Id,
      test_level3_id:      selectedLevel3Id,
      instructions_html:   instructionsHtml || null,
      dedicated_client_id: clientId ? parseInt(clientId) : null,
      test_term_date:      null,
      shuffle_subjects:    isAITS ? shuffleSubjects  : false,
      shuffle_questions:   isAITS ? shuffleQuestions : false,
      shuffle_options:     isAITS ? shuffleOptions   : false,
      created_by:          userName || "",
      last_updated_by:     userName || "",
      subjects:            subjectsPayload,
      set_assignments:     selectedPlanIds.map((id) => ({ subscriber_id: id })),
      course_plan_id_list: selectedPlanIds,
    };

    const url = `${EndPoints.PRISM_CREATE_TEST_SCHEDULE_V1}?shuffle_ques=${isAITS ? shuffleQuestions : true}&shuffle_subject=${isAITS ? shuffleSubjects : false}&shuffle_option=${isAITS ? shuffleOptions : false}`;

    try {
      const result = await POST.withToken(url, payload, { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg });
      if (result?.status === 201 || result?.status === 200) {
        setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>{result.message || "Test schedule created successfully!"}</span></div></div>);
        setIsMessageBoxVisible(true); setActiveImg(SuccessImg);
        setTimeout(() => navigate(-1), 1000);
      }
    } catch (e) { console.error("Error saving:", e); }
  };

  // ═══════════════════════════════════════════════════════════════════════════
  //  RENDER
  // ═══════════════════════════════════════════════════════════════════════════

  // ── Shared styles — sourced from SemanticColors CSS variables ────────────
  // DppInputBorder, DppInputBackground from SemanticColors TealWhiteGrey theme
  // Gray-2 (#6A6A6A) is the canonical text color for all input fields and labels
  const inputStyle = {
    width: "100%",
    padding: "8px 10px",
    border: "1px solid var(--DppInputBorder, #d0d0d0)",
    borderRadius: "0px",                                   // ← removed border-radius
    fontSize: "14px",
    boxSizing: "border-box",
    backgroundColor: "var(--DppInputBackground, #ffffff)",
    color: "var(--Gray-2, #6A6A6A)",                       // ← unified text color
  };

  const disabledStyle = {
    ...inputStyle,
    opacity: 0.55,
    cursor: "not-allowed",
    backgroundColor: "var(--DppDropdownBackground, #f5f5f5)",
  };

  const labelStyle = {
    fontSize: "14px",
    color: "var(--DppLabelText, #6A6A6A)",                 // ← unified label color
    display: "block",
    marginBottom: "5px",
  };

  const SectionHeader = ({ title, visible, onToggle }) => (
    <div className="Header-1-C424342" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "5px" }}>
      <span>{title}</span>
      {visible
        ? <img src={MinusImg} alt="collapse" style={{ cursor: "pointer", width: "24px", height: "10px" }} onClick={onToggle} />
        : <div className="plus" style={{ cursor: "pointer", fontSize: "28px", width: "24px", height: "24px", display: "flex", alignItems: "center", justifyContent: "center", color: "#888", fontWeight: "bold" }} onClick={onToggle}>+</div>
      }
    </div>
  );

  const displaySubjects = getDisplaySubjects();

  return (
    <div className="Leftmargin-Main-DIV">

      {/* ── top bar ── */}
      <div style={{ position: "sticky", top: 0, backgroundColor: "white", zIndex: 1 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "20px", width: "98%" }}>
          <div style={{ fontSize: "30px", color: `${Colors.color1}`, fontWeight: "400", whiteSpace: "nowrap" }}>Test Scheduling</div>
          <div>
            <div className="row-cs-uni">
              <button className="create-test-section-btn" style={{ marginRight: "18px", boxShadow: "0px 4px 4px 0px #00000040" }} onClick={() => navigate(-1)}>CANCEL</button>
              <button className="create-test-section-btn" style={{ marginRight: "0px",  boxShadow: "0px 4px 4px 0px #00000040" }} onClick={handleSave}>SAVE</button>
            </div>
          </div>
        </div>
      </div>

      {/* ════════════════════════════════════════════════════════
          SECTION 1 — TEST DETAILS
      ════════════════════════════════════════════════════════ */}
      <SectionHeader title="TEST DETAILS" visible={detailsVisible} onToggle={() => setDetailsVisible((v) => !v)} />

      {detailsVisible && (
        <div className="Body-1-C424342" style={{ paddingBottom: 16 }}>

          {/* gap: rowGap 8px, columnGap 24px — per design spec */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", columnGap: "24px", rowGap: "8px", paddingRight: "5.5px" }}>

            {/* Row 1: Test Series | Description | Course */}
            <div>
              <ReflectDropdown label="Test Series" style={{ width: "100%" }}
                setSelected={handleTestSeriesSelect} selected={selectedTestSeriesId}
                options={[{ label: "-None-", id: 0 }, ...allTestSeries.map((ts) => ({ label: `${ts.ts_name} - ${ts.course_name || ""}`, id: ts.ts_id }))]}
                isRequired={true}
              />
            </div>
            <div>
              <InputComponent label="Description" style={{ width: "100%" }} value={testSeriesDescription} isRequired={false} disable={true} />
            </div>
            <div>
              <DropDown3 label="Course" style={{ width: "100%" }} setSelected={setCourseOpted} selected={courseOpted}
                options={courses.map((c) => ({ label: c.course_name, id: c.course_id }))} isRequired={false} disabled={true} />
            </div>

            {/* Row 2: Question Paper Name | QP Description | Subjects */}
            <div>
              <DropDown label="Question Paper Name" style={{ width: "100%" }}
                selected={selectedQuesPaperId} setSelected={setSelectedQuesPaperId}
                options={quesPaperList.map((qp) => ({ label: qp.ques_paper_name, id: qp.ques_paper_id }))} isRequired={true} />
            </div>
            <div>
              <InputComponent label="Question Paper Description" style={{ width: "100%" }} value={quesPaperDescription} isRequired={false} disable={true} />
            </div>
            <div>
              <InputComponent label="Subjects" style={{ width: "100%" }} value={testSeriesSubjects} isRequired={false} disable={true} icon={introgativeImgBlue} />
            </div>

            {/* Row 3: QP Created By | Test Name | Description */}
            <div>
              <InputComponent label="Question Paper Created By" style={{ width: "100%" }} value={quesPaperCreatedBy} isRequired={false} disable={true} />
            </div>
            <div>
              <label style={labelStyle}>Test Name <span style={{ color: "red" }}>*</span></label>
              <input type="text" style={seriesSelected ? inputStyle : disabledStyle} value={testName}
                placeholder="Enter test name" disabled={!seriesSelected} onChange={(e) => setTestName(e.target.value)} />
            </div>
            <div>
              <label style={labelStyle}>Description</label>
              <input type="text" style={seriesSelected ? inputStyle : disabledStyle} value={testDescription}
                placeholder="Enter description" disabled={!seriesSelected} onChange={(e) => setTestDescription(e.target.value)} />
            </div>

            {/* Row 4: Test Window Start | Test Window End | Folder Name */}
            <div>
              <label style={labelStyle}>Test Window Start <span style={{ color: "red" }}>*</span></label>
              <input type="datetime-local" style={seriesSelected ? inputStyle : disabledStyle}
                min={getCurrentDateTime()} value={testWindowStart} disabled={!seriesSelected}
                onChange={(e) => setTestWindowStart(e.target.value)} />
            </div>
            <div>
              <label style={labelStyle}>Test Window End <span style={{ color: "red" }}>*</span></label>
              <input type="datetime-local" style={seriesSelected ? inputStyle : disabledStyle}
                min={testWindowStart || getCurrentDateTime()} value={testWindowEnd} disabled={!seriesSelected}
                onChange={(e) => setTestWindowEnd(e.target.value)} />
            </div>
            <div style={{ position: "relative" }}>
              <label style={labelStyle}>
                Folder Name {!isAITS && seriesSelected && <span style={{ color: "red" }}>*</span>}
              </label>
              {/* Folder picker input */}
              <div ref={folderPickerRef} style={{ position: "relative" }}>
                <input
                  type="text"
                  style={
                    seriesSelected && !isAITS
                      ? { ...inputStyle, paddingRight: "30px" }
                      : { ...disabledStyle, paddingRight: "30px" }
                  }
                  value={folderPickerOpen ? folderSearchText : folderName}
                  placeholder="Select or search folder..."
                  disabled={!seriesSelected || isAITS}
                  onChange={(e) => {
                    setFolderSearchText(e.target.value);
                    setExpandedLevel1(null); setExpandedLevel2(null);
                    if (!folderPickerOpen) setFolderPickerOpen(true);
                  }}
                  onFocus={() => { if (!isAITS && seriesSelected) { setFolderPickerOpen(true); setFolderSearchText(""); } }}
                />
                <span
                  onClick={() => { if (!isAITS && seriesSelected) { setFolderPickerOpen((v) => !v); setFolderSearchText(""); setExpandedLevel1(null); setExpandedLevel2(null); } }}
                  style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", color: "var(--Gray-2, #6A6A6A)", cursor: "pointer", fontSize: "11px" }}
                >▼</span>
              </div>

              {/* Folder dropdown */}
              {folderPickerOpen && !isAITS && (
                <div ref={folderDropdownRef} style={{ position: "absolute", top: "100%", left: 0, zIndex: 9999, marginTop: "2px", minWidth: "220px" }}>

                  {folderSearchText.trim() ? (
                    <div style={{ backgroundColor: "var(--DppInputBackground, #fff)", border: "1px solid var(--DppInputBorder, #ddd)", borderRadius: "0px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", maxHeight: "220px", overflowY: "auto", width: "360px" }}>
                      {(() => {
                        const term = folderSearchText.toLowerCase();
                        const results = [];
                        folderLevelData.forEach((l1) => {
                          (l1.level2 || []).forEach((l2) => {
                            const path2 = `${l1.name || "Level 1"} > ${l2.name || "Level 2"}`;
                            if ((l2.name || "").toLowerCase().includes(term)) results.push({ path: path2, l1Id: l1.test_level1_id, l2Id: l2.test_level2_id, l3Id: null });
                            (l2.level3 || []).forEach((l3) => {
                              const path3 = `${path2} > ${l3.name || "Level 3"}`;
                              if ((l3.name || "").toLowerCase().includes(term)) results.push({ path: path3, l1Id: l1.test_level1_id, l2Id: l2.test_level2_id, l3Id: l3.test_level3_id });
                            });
                          });
                        });
                        if (!results.length) return <div style={{ padding: "12px", color: "var(--Gray-2, #6A6A6A)", fontSize: "14px", textAlign: "center" }}>No results found</div>;
                        return results.map((r, i) => (
                          <div key={i} onClick={() => { setFolderName(r.path); setSelectedLevel1Id(r.l1Id); setSelectedLevel2Id(r.l2Id); setSelectedLevel3Id(r.l3Id); setFolderPickerOpen(false); setFolderSearchText(""); }}
                            style={{ padding: "8px 12px", cursor: "pointer", borderBottom: "1px solid var(--DppDropdownItemBorder, #f0f0f0)", fontSize: "14px", color: "var(--Gray-2, #6A6A6A)" }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "var(--DppDropdownHoverBackground, #f0f7ff)"}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "var(--DppInputBackground, #fff)"}>
                            {r.path}
                          </div>
                        ));
                      })()}
                    </div>
                  ) : (
                    <div style={{ display: "flex", alignItems: "flex-start" }}>

                      {/* Level 1 */}
                      <div style={{ backgroundColor: "var(--DppInputBackground, #fff)", border: "1px solid var(--DppInputBorder, #ddd)", borderRadius: "0px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", width: "170px", maxHeight: "220px", overflowY: "auto" }}>
                        {folderLevelData.length === 0
                          ? <div style={{ padding: "12px", color: "var(--Gray-2, #6A6A6A)", fontSize: "14px" }}>No folders available</div>
                          : folderLevelData.map((l1) => (
                            <div key={l1.test_level1_id}
                              onMouseEnter={() => { setExpandedLevel1(l1.test_level1_id); setExpandedLevel2(null); }}
                              style={{ padding: "8px 10px", backgroundColor: expandedLevel1 === l1.test_level1_id ? "var(--DppDropdownHoverBackground, #f0f7ff)" : "var(--DppInputBackground, #fff)", cursor: "default", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid var(--DppDropdownItemBorder, #f0f0f0)", fontSize: "14px", color: "var(--Gray-2, #6A6A6A)", fontWeight: "500" }}>
                              <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{l1.name || "(No name)"}</span>
                              {(l1.level2 || []).length > 0 && <span style={{ fontSize: "9px", color: "var(--Gray-2, #6A6A6A)", flexShrink: 0, marginLeft: "4px" }}>▶</span>}
                            </div>
                          ))
                        }
                      </div>

                      {/* Level 2 */}
                      {expandedLevel1 && (() => {
                        const l1 = folderLevelData.find((x) => x.test_level1_id === expandedLevel1);
                        if (!l1?.level2?.length) return null;
                        return (
                          <div style={{ backgroundColor: "var(--DppInputBackground, #fff)", border: "1px solid var(--DppInputBorder, #ddd)", borderRadius: "0px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", width: "170px", maxHeight: "220px", overflowY: "auto", marginLeft: "3px" }}>
                            {l1.level2.map((l2) => (
                              <div key={l2.test_level2_id}
                                onMouseEnter={() => setExpandedLevel2(l2.test_level2_id)}
                                onClick={() => { const path = `${l1.name || "L1"} > ${l2.name || "L2"}`; setFolderName(path); setSelectedLevel1Id(l1.test_level1_id); setSelectedLevel2Id(l2.test_level2_id); setSelectedLevel3Id(null); setFolderPickerOpen(false); setExpandedLevel1(null); setExpandedLevel2(null); }}
                                style={{ padding: "8px 10px", backgroundColor: expandedLevel2 === l2.test_level2_id ? "var(--DppDropdownHoverBackground, #f0f7ff)" : "var(--DppInputBackground, #fff)", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid var(--DppDropdownItemBorder, #f0f0f0)", fontSize: "14px", color: "var(--Gray-2, #6A6A6A)" }}>
                                <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{l2.name || "(No name)"}</span>
                                {(l2.level3 || []).length > 0 && <span style={{ fontSize: "9px", color: "var(--Gray-2, #6A6A6A)", flexShrink: 0, marginLeft: "4px" }}>▶</span>}
                              </div>
                            ))}
                          </div>
                        );
                      })()}

                      {/* Level 3 */}
                      {expandedLevel2 && (() => {
                        const l1 = folderLevelData.find((x) => x.test_level1_id === expandedLevel1);
                        const l2 = l1?.level2?.find((x) => x.test_level2_id === expandedLevel2);
                        if (!l2?.level3?.length) return null;
                        return (
                          <div style={{ backgroundColor: "var(--DppInputBackground, #fff)", border: "1px solid var(--DppInputBorder, #ddd)", borderRadius: "0px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", width: "170px", maxHeight: "220px", overflowY: "auto", marginLeft: "3px" }}>
                            {l2.level3.map((l3) => (
                              <div key={l3.test_level3_id}
                                onClick={() => { const path = `${l1.name || "L1"} > ${l2.name || "L2"} > ${l3.name || "L3"}`; setFolderName(path); setSelectedLevel1Id(l1.test_level1_id); setSelectedLevel2Id(l2.test_level2_id); setSelectedLevel3Id(l3.test_level3_id); setFolderPickerOpen(false); setExpandedLevel1(null); setExpandedLevel2(null); }}
                                style={{ padding: "8px 10px", cursor: "pointer", borderBottom: "1px solid var(--DppDropdownItemBorder, #f0f0f0)", fontSize: "14px", color: "var(--Gray-2, #6A6A6A)" }}
                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "var(--DppDropdownHoverBackground, #f0f7ff)"}
                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "var(--DppInputBackground, #fff)"}>
                                <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "block" }}>{l3.name || "(No name)"}</span>
                              </div>
                            ))}
                          </div>
                        );
                      })()}
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Row 5: Duration | No. of Sets | Shuffle Subject */}
            <div>
              <label style={labelStyle}>Duration (mins) <span style={{ color: "red" }}>*</span></label>
              <input type="number" style={seriesSelected ? inputStyle : disabledStyle}
                value={duration} placeholder="In minutes" disabled={!seriesSelected}
                onChange={(e) => setDuration(e.target.value)} />
            </div>
            <div>
              <ReflectDropdown
                label="No. of Sets"
                style={{ width: "100%" }}
                options={[1,2,3,4,5,6].map((n) => ({ label: String(n), id: n }))}
                selected={numberOfSets}
                setSelected={(val) => setNumberOfSets(val)}
                isDisabled={!seriesSelected || !isAITS}
              />
            </div>
            <div>
              <ReflectDropdown
                label="Shuffle Subject"
                style={{ width: "100%" }}
                options={[{ label: "No", id: 0 }, { label: "Yes", id: 1 }]}
                selected={shuffleSubjects ? 1 : 0}
                setSelected={(val) => setShuffleSubjects(Boolean(val))}
                isDisabled={!seriesSelected || !isAITS}
              />
            </div>

            {/* Row 6: Shuffle Question | Shuffle Option | empty */}
            <div>
              <ReflectDropdown
                label="Shuffle Question"
                style={{ width: "100%" }}
                options={[{ label: "Yes", id: 1 }, { label: "No", id: 0 }]}
                selected={shuffleQuestions ? 1 : 0}
                setSelected={(val) => setShuffleQuestions(Boolean(val))}
                isDisabled={!seriesSelected || !isAITS}
              />
            </div>
            <div>
              <ReflectDropdown
                label="Shuffle Option"
                style={{ width: "100%" }}
                options={[{ label: "No", id: 0 }, { label: "Yes", id: 1 }]}
                selected={shuffleOptions ? 1 : 0}
                setSelected={(val) => setShuffleOptions(Boolean(val))}
                isDisabled={!seriesSelected || !isAITS}
              />
            </div>
            <div />

            {/* Instructions — spans all 3 columns */}
            <div style={{ gridColumn: "1 / -1" }}>
              <TextEditor templates={testTemplates} value={instructionsHtml}
                setValue={seriesSelected ? setInstructionsHtml : () => {}} />
            </div>

          </div>
        </div>
      )}

      {/* ════════════════════════════════════════════════════════
          SECTION 2 — COURSE PLANS
      ════════════════════════════════════════════════════════ */}
      <div style={{ marginTop: "20px" }}>
        <SectionHeader title="COURSE PLANS" visible={coursePlansVisible} onToggle={() => setCoursePlansVisible((v) => !v)} />

        {coursePlansVisible && (
          <div className="Body-1-C424342" style={{ paddingBottom: 16 }}>
            {!seriesSelected ? (
              <div style={{ color: "var(--Gray-2, #6A6A6A)", fontSize: "14px", padding: "8px 15px" }}>Select a Test Series to view course plans.</div>
            ) : (
              <div style={{ paddingRight: "5.5px" }}>
                <CoursePlanTable coursePlans={coursePlans} selectedPlanIds={selectedPlanIds} setSelectedPlanIds={setSelectedPlanIds} />
              </div>
            )}
          </div>
        )}
      </div>

      {/* ════════════════════════════════════════════════════════
          SECTION 3 — MARKING SCHEME
      ════════════════════════════════════════════════════════ */}
      <div style={{ marginTop: "20px" }}>
        <SectionHeader title="MARKING SCHEME" visible={markingSchemeVisible} onToggle={() => setMarkingSchemeVisible((v) => !v)} />

        {markingSchemeVisible && (
          <div className="Body-1-C424342" style={{ padding: "15px", color: `${Colors.color1}`, marginBottom: "10px" }}>
            {!seriesSelected ? (
              <div style={{ color: "var(--Gray-2, #6A6A6A)", fontSize: "14px", padding: "8px 0" }}>Select a Test Series to configure marking scheme.</div>
            ) : displaySubjects.length === 0 ? (
              <div style={{ color: "var(--Gray-2, #6A6A6A)", fontSize: "14px", padding: "8px 0" }}>Select a question paper to configure marking scheme.</div>
            ) : (
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", columnGap: "24px", rowGap: "8px", paddingRight: "5.5px" }}>
                {displaySubjects.map((subject) => {
                  const ssId     = subject.subject_superset_id;
                  const ssName   = subject.subject_superset_name || subject.subject_name || "";
                  const sections = getDeduplicatedSections(subject);
                  return sections.map((section, sectionIdx) => {
                    const key        = `${ssId}-${sectionIdx + 1}`;
                    const selectedId = selectedMarkingSchemes?.[key] ?? null;
                    const scheme     = markingSchemeList.find((ms) => ms.ms_id === selectedId);
                    return (
                      <React.Fragment key={`${ssId}-${section.section_no}-${sectionIdx}`}>
                        {/* Col 1: label + dropdown */}
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", minWidth: 0 }}>
                          <span style={{ fontSize: "14px", color: "var(--Gray-2, #6A6A6A)", whiteSpace: "nowrap", flexShrink: 0 }}>
                            {ssName} - {section.section_name || `Section ${sectionIdx + 1}`}
                          </span>
                          <div style={{ width: "300px", flexShrink: 0 }}>
                            <ReflectDropdown
                              style={{ width: "100%" }}
                              options={markingSchemeList.map((ms) => ({ label: ms.ms_name, id: ms.ms_id }))}
                              selected={selectedId}
                              setSelected={(val) => handleMarkingSchemeChange(ssId, sectionIdx, val)}
                            />
                          </div>
                        </div>
                        {/* Col 2: description */}
                        <div style={{ display: "flex", alignItems: "center", fontSize: "14px", color: "var(--Gray-2, #6A6A6A)", minWidth: 0, overflow: "hidden" }}>
                          <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {scheme ? `${scheme.expression} ; ${scheme.ms_desc}` : "—"}
                          </span>
                        </div>
                        {/* Col 3: blank */}
                        <div />
                      </React.Fragment>
                    );
                  });
                })}
              </div>
            )}
          </div>
        )}
      </div>

      <div style={{ height: "80px" }} />
    </div>
  );
};

export default TestScheduling;